var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category",style:({
  marginRight: (_vm.index + 1) % 3 === 0 ? '0' : '1rem'
  }),on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave,"click":function($event){_vm.handleClick(_vm.conformation.num)}}},[_c('div',{ref:"conformation-icon",staticClass:"conformationIcon",style:({
      backgroundImage : this.selected ?
      ("url(//" + (_vm.conformation.savedUrl) + "check.png)")
      : ("url(//" + (_vm.conformation.savedUrl) + "contactus/" + (_vm.conformation.contactUsImage) + ")")
       ,
      backgroundColor : this.selected ? this.selectedBackgroundColor : this.unselectedBackgroundcolor ,

    })}),_vm._v(" "),_c('div',{ref:"conformation-name",staticClass:"conformationName",style:({
        backgroundColor : this.selected ? this.selectedBackgroundColor : this.unselectedBackgroundcolor ,
        color : this.selected ? '#fff' : '#000'
       })},[_vm._v("\n    "+_vm._s(_vm.conformation.name)+"\n    "),_c('div',{ref:"conformation-comment"},[_vm._v("\n      "+_vm._s(_vm.conformation.comment !== '' ? ("(" + (_vm.conformation.comment) + ")") : "")+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1788722c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/ContactUs/Category.vue
// module id = null
// module chunks = 